export default __webpack_public_path__ + "86a18cd235890f9f88eb94fd09d564bc.png";